import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import { Layer, Source } from 'react-map-gl';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const OrienteeringPage2 = (props: Props): JSX.Element => {
    return (
        <S_OrienteeringPage2 className={props.className}>
            <CustomMapPage
                mapId={'0f076f24-deaa-4be2-ad15-4453d6bb77ae'}
                onMapLoaded={() => {
                    console.log('Map loaded');
                }}
                mapChildren={
                    <>
                        <Source
                            type="image"
                            url="https://dvtqxks0zalev.cloudfront.net/4096/911fb5c3-5661-4ccf-8b10-a2d8ff1638e3.jpeg"
                            //UTM to latlng
                            //Top left: 571860.3, 7033030.3
                            // Top right: 573719.7,  7033030.3
                            // Bottom left: 571860.3, 7031752.6
                            // Bottom right: 573719.7, 7031752.6

                            coordinates={[
                                [10.439427, 63.418539],
                                [10.476657, 63.418159],

                                [10.476068, 63.406696],
                                [10.438852, 63.407076]
                            ]}
                        >
                            <Layer
                                id="radar-layer"
                                type="raster"
                                paint={{
                                    'raster-fade-duration': 0,
                                    'raster-opacity': 1
                                }}
                            />
                        </Source>
                    </>
                }
            />
        </S_OrienteeringPage2>
    );
};

const S_OrienteeringPage2 = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
